import axios from "../axiosInstance";

class HomologationStatusService {
  async getHomologationStatusList() {
    return await axios.get("homologationStatus");
  }
}

export default new HomologationStatusService();
